import React, { useState } from "react";
import { Row, Col, Button, Drawer } from '@whalecloud/fdx';
import ColumnSettingTable from '@components/ColumnSettingTable';
import { getLocale } from "@utils/util";

const ColumnSettings = ({ updateElement }) => {
  const messages = getLocale();

  const [visible, setVisible] = useState(false);

  const showDrawer = e => {
    setVisible(true);
  }

  const handleClose = () => {
    setVisible(false);
  }

  return (
    <Row span={24}>
      <Col span={8} style={{ textAlign: 'right', fontSize: '14px', paddingRight: '8px' }}>
        {messages['PAGEBUIDER_SETTINGS_FORM_TABS_COLUMN']}
      </Col>
      <Col span={16} style={{ paddingBottom: '10px' }}>
        <Button type="primary" onClick={showDrawer}>{messages['PAGEBUIDER_SETTINGS_EDIT_COLUMNS_DATA']}</Button>
        <Drawer destroyOnClose width={800} closable={false} visible={visible} onClose={handleClose} title={messages['PAGEBUIDER_SETTINGS_EDIT_COLUMNS_DATA']}>
          <ColumnSettingTable handleClose={handleClose} updateElement={updateElement} />
        </Drawer>
      </Col>
    </Row>
  );
}

export default ColumnSettings;
